export default __webpack_public_path__ + "static/media/gallery_00.4d8a14cc.jpg";